export default "__VITE_ASSET__BGgxt$I$__"